import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import AiTeamDropDown from "../Components/AiTeamDropDown";
import EmptyComponent from "../Components/EmptyComponent";

export default function AllProjectEmpty() {
  return (
    <div>
      <DashboardLayout>
        <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
          <Breadcrumbs links={[{ name: "AI Projects", link: "dsads" }]} />
          <h1 className="text-xl font-semibold">All AI Projects</h1>
          <div className="flex items-center gap-6">
            <div className="flex items-center ">
              <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[22rem]">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search AI Projects"
                  className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
                />
              </div>
              <div>
                <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                  Search
                </button>
              </div>
            </div>
            <AiTeamDropDown
              text="Status"
              width="8.75rem"
              options={["Not Assigned", "In Progress", "Completed", "All"]}
            />
            <AiTeamDropDown
              text="Stage"
              width="8.75rem"
              options={["Ideation", "Exploration", "Development", "Deployment"]}
            />
            {/* <AiTeamDropDown text="Department" width="8.75rem" /> */}
            <AiTeamDropDown
              text="Beneficiary"
              width="12rem"
              options={[
                "Executive Management",
                "Exploration and Production",
                "Refining, Marketing, and Distribution",
                "Research and Development (R&D)",
                "Human Resources",
                "Finance and Accounting",
                "Information Technology",
                "Legal and Compliance",
                "Corporate Affairs / Public Relations",
                "Supply Chain and Procurement",
                "Health, Safety, and Environment (HSE)",
                "Corporate Strategy and Business Development",
                "Upstream",
                "Midstream",
                "Downstream",
                "Aramco Digital Co",
                "Explorium",
                "Refinery",
                "Other     ",
              ]?.sort()}
            />
            {/* <AiTeamDropDown text="Project Lead" width="8.75rem" /> */}
          </div>
        </section>
        <section className="bg-[#f9fafb] w-full h-screen pt-6 px-6 pb-8">
        <div className="flex items-center justify-center h-full">
        <div className="w-[60%]">
            <EmptyComponent title='No AI Projects have been posted yet.' text='But as soon as the admin posts a project, everything that’s happening with your AI projects will be summarized for you right here.  It’s great for catching up and for seeing what everyone else is up to! ' />
        </div>
        </div>
        </section>
      </DashboardLayout>
    </div>
  );
}
